// extracted by mini-css-extract-plugin
export default {"secondaryButton":"secondaryButton__1Wqkl","buttonContentWrapper":"buttonContentWrapper__2Y7wX"};
    if(module.hot) {
      // 1764953343838
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  